import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { Category, CategoryCompany } from 'src/app/core/models/categories.models';
import { StringStringMap } from 'src/app/core/models/common.models';
import { CompaniesBackendService } from 'src/app/core/services/backend/companies-backend.service';

@Component({
  selector: 'craft-category-companies',
  templateUrl: './craft-category-companies.component.html',
  styleUrls: ['./craft-category-companies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftCategoryCompaniesComponent implements OnInit, OnChanges {
  @Input() public viewType: 'list' | 'details';
  @Input() public category: Category;

  public ideasMapping: StringStringMap = { '=0': 'idea.zero', '=1': 'activity.idea', other: 'activity.ideas' };
  public companiesNamesTruncated: string;
  public companies$: Observable<CategoryCompany[]>;

  constructor(private companiesService: CompaniesBackendService) {}

  public ngOnInit() {
    this.companies$ = this.companiesService.getCategoryCompanies(this.category.productId, this.category.id);
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.category) {
      this.companiesNamesTruncated = this.category.companiesNames.join(', ');
    }
  }

  public identify(index: number, company?: CategoryCompany): string | number {
    return company?.id || index;
  }
}
